var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.376776 0.366003C0.135527 0.600425 0 0.918327 0 1.2498C0 1.58127 0.135527 1.89917 0.376776 2.1336L8.09796 9.634C8.33928 9.86835 8.66654 10 9.00777 10C9.349 10 9.67626 9.86835 9.91758 9.634L17.6388 2.1336C17.8732 1.89783 18.0029 1.58206 18 1.2543C17.997 0.926535 17.8617 0.613003 17.6231 0.38123C17.3845 0.149458 17.0617 0.0179898 16.7243 0.0151416C16.3869 0.0122934 16.0618 0.138293 15.8191 0.366003L9.00777 6.98261L2.1964 0.366003C1.95508 0.131651 1.62782 0 1.28659 0C0.945358 0 0.618099 0.131651 0.376776 0.366003Z",
    fill: "#6E3DE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.0b026d10c52c921972585010b17c473c.svg";
export { ForwardRef as ReactComponent };